import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import ChangePassword from './views/ChangePassword.vue';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import NewPassword from './views/NewPassword.vue';
import ResetPassword from './views/ResetPassword.vue';

import ApplicationForm from './views/Application/Form.vue';
import ApplicationIndex from './views/Application/Index.vue';
import ApplicationShow from './views/Application/Show.vue';
import ApplicationThankYou from './views/Application/ThankYou.vue';

import PartnerApplication from './views/Partner/Application.vue';
import CardNumbers from './views/Partner/CardNumbers.vue';
import PartnerIndex from './views/Partner/Index.vue';
import PartnerShow from './views/Partner/Show.vue';
import PartnerEdit from '@/views/Partner/Edit.vue';
import UserEdit from '@/views/User/UserEdit.vue';
import User from '@/views/User/User.vue';
import UserDelete from '@/views/User/Delete.vue';


Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/ziadosti',
            name: 'applications',
            component: ApplicationIndex,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/ziadosti/:application',
            name: 'application_show',
            component: ApplicationShow,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/uzivatelia',
            name: 'users',
            component: User,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/users/create',
            name: 'user_create',
            component: UserEdit,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/users/edit/:user',
            name: 'user_edit',
            component: UserEdit,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/users/delete/:user',
            name: 'user_delete',
            component: UserDelete,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partneri',
            name: 'partners',
            component: PartnerIndex,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partner/ziadosti',
            name: 'partner_applications',
            component: PartnerApplication,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partner/:partner',
            name: 'partner_show',
            component: PartnerShow,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partner/edit/:partner',
            name: 'partner_edit',
            component: PartnerEdit,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partners/create',
            name: 'partner_create',
            component: PartnerEdit,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/partner/:partner/card-numbers',
            name: 'partner_cardNumbers',
            component: CardNumbers,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                requiresUnauth: true,
            },
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword,
            meta: {
                requiresUnauth: true,
            },
        },
        {
            path: '/new-password/:token',
            name: 'new-password',
            component: NewPassword,
            meta: {
                requiresUnauth: false,
            },
        },
        {
          path: '/change-password',
          name: 'change-password',
          component: ChangePassword,
          meta: {
              requiresAuth: true,
          },
        },
        {
            path: '/formular/dakujeme',
            component: ApplicationThankYou,
        },
        {
            path: '/formular/:partner',
            name: 'form',
            component: ApplicationForm,
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return;
        }
        next({ name: 'login', query: { redirect: to.fullPath } });
    } else {
        next();
    }

    if (to.matched.some((record) => record.meta.requiresUnauth)) {
        if (!store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/');
    } else {
        next();
    }
});

export default router;
